import { AdminFormAction, AdminFormActionTypes } from '@completion/actions';
import { AdminFormDto, AdminFormListItemDto, PaginatedResponse } from '@completion/models';

export interface AdminFormState {
  currentForm: AdminFormDto | null;
  forms: AdminFormListItemDto[];
  formsResponse: PaginatedResponse<AdminFormListItemDto> | null;
  notFound: boolean | null;
}

export const initialState: AdminFormState = {
  currentForm: null,
  forms: [],
  formsResponse: null,
  notFound: null,
};

export function adminFormReducer(state: AdminFormState = initialState, action: AdminFormAction): AdminFormState {
  switch (action.type) {
    case AdminFormActionTypes.AdminFormLoadSuccess:
    case AdminFormActionTypes.AdminFormCreateSuccess:
    case AdminFormActionTypes.AdminFormUpdateSuccess:
      return {
        ...state,
        currentForm: action.form,
        notFound: false,
      };

    case AdminFormActionTypes.AdminFormsListLoadSuccess:
      return {
        ...state,
        forms: action.formsResponse.content,
        formsResponse: action.formsResponse,
      };

    case AdminFormActionTypes.AdminFormLoadFail:
    case AdminFormActionTypes.AdminFormsListLoadFail:
      return {
        ...state,
        notFound: action.error?.status === 404,
      };

    case AdminFormActionTypes.AdminFormDeleteSuccess:
    case AdminFormActionTypes.AdminFormUnload:
      return initialState;

    default:
      return state;
  }
}
